import React from 'react';
import { MessageCircle, MoreHorizontal, Share2, ThumbsUp, Pen, Smile, Camera, Image as ImageIcon, Sticker } from 'lucide-react';
export function Testimonials() {
  return <section className="py-20 px-4 bg-[#f0f2f5]" data-id="element-344">
      <div className="max-w-6xl mx-auto" data-id="element-345">
        {/* Branded Section Header */}
        <h2 className="text-3xl md:text-5xl font-bold text-center text-teal-500 mb-12 font-baloo drop-shadow-sm" data-id="element-346">
          ⭐ WHAT FAMILIES WHO ALREADY HAVE THEIR KIT ARE SAYING
        </h2>

        {/* Facebook Feed Container */}
        <div className="max-w-lg mx-auto" data-id="element-347">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 pt-3 pb-4" style={{
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
        }} data-id="element-348">
            {/* Product Post Header */}
            <div className="px-4 mb-3 flex items-start justify-between" data-id="element-349">
              <div data-id="element-350">
                <div className="text-[#65676b] text-[12px] font-semibold uppercase tracking-wide mb-0.5" data-id="element-351">
                  MUNDOINFANTILDIGITAL.SHOP
                </div>
                <h3 className="text-[#050505] text-[17px] font-bold leading-tight mb-1" data-id="element-352">
                  Create Magical Parties at Home 🪄
                </h3>
                <div className="flex items-center gap-1 text-[14px] text-[#65676b]" data-id="element-353">
                  <div className="flex text-yellow-400 text-[16px] tracking-tighter" data-id="element-354">
                    ★★★★★
                  </div>
                  <span data-id="element-355">5/5</span>
                </div>
              </div>
              <button className="bg-[#e4e6eb] hover:bg-[#d8dadf] text-[#050505] font-semibold text-[15px] px-4 py-1.5 rounded-md transition-colors" data-id="element-356">
                Shop
              </button>
            </div>

            {/* Reactions Bar */}
            <div className="px-4 py-2 flex items-center justify-between text-[#65676b] text-[15px]" data-id="element-357">
              <div className="flex items-center gap-1.5" data-id="element-358">
                <div className="flex -space-x-1" data-id="element-359">
                  <div className="w-[18px] h-[18px] rounded-full bg-[#1877F2] flex items-center justify-center text-white text-[10px] ring-2 ring-white z-10" data-id="element-360">
                    👍
                  </div>
                  <div className="w-[18px] h-[18px] rounded-full bg-[#f33e58] flex items-center justify-center text-white text-[10px] ring-2 ring-white" data-id="element-361">
                    ❤️
                  </div>
                </div>
                <span className="hover:underline cursor-pointer" data-id="element-362">258</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-363">
                <span className="hover:underline cursor-pointer flex items-center gap-1" data-id="element-364">
                  345 <MessageCircle className="w-4 h-4" data-id="element-365" />
                </span>
                <span className="hover:underline cursor-pointer flex items-center gap-1" data-id="element-366">
                  89 <Share2 className="w-4 h-4" data-id="element-367" />
                </span>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="px-4" data-id="element-368">
              <hr className="border-[#ced0d4]" data-id="element-369" />
              <div className="flex items-center justify-between py-1" data-id="element-370">
                <button className="flex-1 flex items-center justify-center gap-2 py-1.5 text-[#65676b] font-semibold text-[15px] hover:bg-[#f2f2f2] rounded-md transition-colors" data-id="element-371">
                  <ThumbsUp className="w-5 h-5" data-id="element-372" />
                  Like
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 py-1.5 text-[#65676b] font-semibold text-[15px] hover:bg-[#f2f2f2] rounded-md transition-colors" data-id="element-373">
                  <MessageCircle className="w-5 h-5" data-id="element-374" />
                  Comment
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 py-1.5 text-[#65676b] font-semibold text-[15px] hover:bg-[#f2f2f2] rounded-md transition-colors" data-id="element-375">
                  <Share2 className="w-5 h-5" data-id="element-376" />
                  Share
                </button>
              </div>
              <hr className="border-[#ced0d4] mb-3" data-id="element-377" />
            </div>

            {/* Sort Dropdown */}
            <div className="px-4 mb-4" data-id="element-378">
              <button className="text-[#65676b] font-semibold text-[15px] hover:bg-[#f2f2f2] px-2 py-1 rounded-md transition-colors flex items-center gap-1" data-id="element-379">
                Most recent <span className="text-[10px]" data-id="element-380">▼</span>
              </button>
            </div>

            {/* Comments List */}
            <div className="px-4 space-y-4" data-id="element-381">
              {/* Comment 1: Laura García */}
              <div data-id="element-382">
                <div className="flex items-start gap-2" data-id="element-383">
                  <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-[14px] flex-shrink-0 mt-1" data-id="element-384">
                    L
                  </div>
                  <div className="flex-1" data-id="element-385">
                    <div className="flex items-center gap-2" data-id="element-386">
                      <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-[90%]" data-id="element-387">
                        <div className="font-semibold text-[#050505] text-[13px] hover:underline cursor-pointer leading-tight mb-0.5" data-id="element-388">
                          Laura García
                        </div>
                        <div className="text-[#050505] text-[15px] leading-snug" data-id="element-389">
                          Does it have Bluey and Cocomelon designs? My daughter
                          is obsessed with those characters 😍
                        </div>
                      </div>
                      <button className="w-8 h-8 rounded-full hover:bg-[#f2f2f2] flex items-center justify-center text-[#65676b] flex-shrink-0" data-id="element-390">
                        <MoreHorizontal className="w-5 h-5" data-id="element-391" />
                      </button>
                    </div>
                    <div className="flex items-center gap-3 text-[#65676b] text-[12px] font-semibold mt-1 ml-3" data-id="element-392">
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-393">
                        1w
                      </span>
                      <span className="hover:underline cursor-pointer" data-id="element-394">
                        Like
                      </span>
                      <span className="hover:underline cursor-pointer" data-id="element-395">
                        Reply
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-396">
                        See translation
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-397">
                        Hide
                      </span>
                    </div>
                  </div>
                </div>

                {/* Expanded Reply (MAGIC PARTY KIT) */}
                <div className="ml-10 mt-2" data-id="element-398">
                  <div className="flex items-start gap-2" data-id="element-399">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center text-white font-bold text-[8px] flex-shrink-0 mt-1 shadow-sm" data-id="element-400">
                      MD
                    </div>
                    <div className="flex-1" data-id="element-401">
                      <div className="flex items-center gap-2" data-id="element-402">
                        <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-[90%]" data-id="element-403">
                          <div className="flex items-center gap-1 text-[#65676b] text-[11px] font-semibold mb-0.5" data-id="element-404">
                            <Pen className="w-3 h-3" data-id="element-405" /> Author
                          </div>
                          <div className="font-semibold text-[#050505] text-[13px] hover:underline cursor-pointer leading-tight mb-0.5" data-id="element-406">
                            MUNDO DECO
                          </div>
                          <div className="text-[#050505] text-[15px] leading-snug" data-id="element-407">
                            <span className="text-[#1877F2] hover:underline cursor-pointer bg-[#e7f3ff] px-0.5 rounded" data-id="element-408">
                              Laura García
                            </span>{' '}
                            Yes! We have over 200 characters including Bluey,
                            Cocomelon, Paw Patrol, and many more 🎉
                          </div>
                        </div>
                        <button className="w-8 h-8 rounded-full hover:bg-[#f2f2f2] flex items-center justify-center text-[#65676b] flex-shrink-0" data-id="element-409">
                          <MoreHorizontal className="w-5 h-5" data-id="element-410" />
                        </button>
                      </div>
                      <div className="flex items-center gap-3 text-[#65676b] text-[12px] font-semibold mt-1 ml-3" data-id="element-411">
                        <span className="font-normal hover:underline cursor-pointer" data-id="element-412">
                          1w
                        </span>
                        <span className="hover:underline cursor-pointer" data-id="element-413">
                          Like
                        </span>
                        <span className="hover:underline cursor-pointer" data-id="element-414">
                          Reply
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Reply Input */}
                  <div className="flex items-center gap-2 mt-2" data-id="element-415">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center text-white font-bold text-[8px] flex-shrink-0 shadow-sm" data-id="element-416">
                      MD
                    </div>
                    <div className="flex-1 bg-[#f0f2f5] rounded-full px-3 py-1.5 flex items-center justify-between" data-id="element-417">
                      <span className="text-[#65676b] text-[13px]" data-id="element-418">
                        Reply as MUNDO DECO
                      </span>
                      <div className="flex items-center gap-2 text-[#65676b]" data-id="element-419">
                        <Smile className="w-4 h-4 cursor-pointer hover:text-[#050505]" data-id="element-420" />
                        <Camera className="w-4 h-4 cursor-pointer hover:text-[#050505]" data-id="element-421" />
                        <ImageIcon className="w-4 h-4 cursor-pointer hover:text-[#050505]" data-id="element-422" />
                        <Sticker className="w-4 h-4 cursor-pointer hover:text-[#050505]" data-id="element-423" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Comment 2: María Torres */}
              <div data-id="element-424">
                <div className="flex items-start gap-2" data-id="element-425">
                  <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center text-white font-bold text-[14px] flex-shrink-0 mt-1" data-id="element-426">
                    M
                  </div>
                  <div className="flex-1" data-id="element-427">
                    <div className="flex items-center gap-2" data-id="element-428">
                      <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-[90%]" data-id="element-429">
                        <div className="font-semibold text-[#050505] text-[13px] hover:underline cursor-pointer leading-tight mb-0.5" data-id="element-430">
                          María Torres
                        </div>
                        <div className="text-[#050505] text-[15px] leading-snug" data-id="element-431">
                          I bought it yesterday and already printed everything
                          for my daughter's party. It turned out amazing! Super
                          easy to use from my phone
                        </div>
                      </div>
                      <button className="w-8 h-8 rounded-full hover:bg-[#f2f2f2] flex items-center justify-center text-[#65676b] flex-shrink-0" data-id="element-432">
                        <MoreHorizontal className="w-5 h-5" data-id="element-433" />
                      </button>
                    </div>
                    <div className="flex items-center gap-3 text-[#65676b] text-[12px] font-semibold mt-1 ml-3" data-id="element-434">
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-435">
                        3w
                      </span>
                      <span className="text-[#1877F2] hover:underline cursor-pointer" data-id="element-436">
                        Like
                      </span>
                      <span className="hover:underline cursor-pointer" data-id="element-437">
                        Reply
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-438">
                        See translation
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-439">
                        Hide
                      </span>
                      <div className="w-[16px] h-[16px] rounded-full bg-[#1877F2] flex items-center justify-center text-white text-[9px] ring-2 ring-white ml-auto mr-4" data-id="element-440">
                        👍
                      </div>
                    </div>
                  </div>
                </div>
                {/* Collapsed Reply */}
                <div className="ml-10 mt-1 flex items-center gap-2 cursor-pointer hover:underline" data-id="element-441">
                  <div className="w-5 h-5 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center text-white font-bold text-[7px] shadow-sm" data-id="element-442">
                    MD
                  </div>
                  <span className="text-[#65676b] font-semibold text-[13px]" data-id="element-443">
                    MUNDO DECO replied · 1 reply
                  </span>
                </div>
              </div>

              {/* Comment 3: Carmen Rodríguez */}
              <div data-id="element-444">
                <div className="flex items-start gap-2" data-id="element-445">
                  <div className="w-8 h-8 rounded-full bg-purple-500 flex items-center justify-center text-white font-bold text-[14px] flex-shrink-0 mt-1" data-id="element-446">
                    C
                  </div>
                  <div className="flex-1" data-id="element-447">
                    <div className="flex items-center gap-2" data-id="element-448">
                      <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-[90%]" data-id="element-449">
                        <div className="font-semibold text-[#050505] text-[13px] hover:underline cursor-pointer leading-tight mb-0.5" data-id="element-450">
                          Carmen Rodríguez
                        </div>
                        <div className="text-[#050505] text-[15px] leading-snug" data-id="element-451">
                          Can you send me a message? I want to know if it can be
                          customized with my son's name
                        </div>
                      </div>
                      <button className="w-8 h-8 rounded-full hover:bg-[#f2f2f2] flex items-center justify-center text-[#65676b] flex-shrink-0" data-id="element-452">
                        <MoreHorizontal className="w-5 h-5" data-id="element-453" />
                      </button>
                    </div>
                    <div className="flex items-center gap-3 text-[#65676b] text-[12px] font-semibold mt-1 ml-3" data-id="element-454">
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-455">
                        5w
                      </span>
                      <span className="text-[#1877F2] hover:underline cursor-pointer" data-id="element-456">
                        Like
                      </span>
                      <span className="hover:underline cursor-pointer" data-id="element-457">
                        Reply
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-458">
                        See translation
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-459">
                        Hide
                      </span>
                      <div className="w-[16px] h-[16px] rounded-full bg-[#1877F2] flex items-center justify-center text-white text-[9px] ring-2 ring-white ml-auto mr-4" data-id="element-460">
                        👍
                      </div>
                    </div>
                  </div>
                </div>
                {/* Collapsed Reply */}
                <div className="ml-10 mt-1 flex items-center gap-2 cursor-pointer hover:underline" data-id="element-461">
                  <div className="w-5 h-5 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center text-white font-bold text-[7px] shadow-sm" data-id="element-462">
                    MD
                  </div>
                  <span className="text-[#65676b] font-semibold text-[13px]" data-id="element-463">
                    MUNDO DECO replied · 1 reply
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}